var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "emoji" }, [
    _c(
      "ul",
      { staticClass: "emoji-controller" },
      _vm._l(_vm.pannels, function (pannel, index) {
        return _c(
          "li",
          {
            key: index,
            class: { active: index === _vm.activeIndex },
            on: {
              click: function ($event) {
                return _vm.changeActive(index)
              },
            },
          },
          [_vm._v("\n      " + _vm._s(pannel) + "\n    ")]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "emoji-container" },
      _vm._l(_vm.emojis, function (emojiGroup, index) {
        return index === _vm.activeIndex
          ? _c(
              "li",
              { key: index, staticStyle: { padding: "0" } },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(emojiGroup) +
                    "--" +
                    _vm._s(index) +
                    "\n      "
                ),
                _vm._l(emojiGroup, function (emoji, index) {
                  return _c(
                    "a",
                    {
                      key: index,
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function ($event) {
                          return _vm.selectItem(emoji)
                        },
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "emoji-item",
                        class: "sprite-" + _vm.getPureName(emoji),
                        attrs: { title: emoji },
                      }),
                    ]
                  )
                }),
              ],
              2
            )
          : _vm._e()
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }